import { useEffect, useState } from "react";
import { IDocumentTableProps } from "./DocumentTableInterfaces";
import { useMsal } from "@azure/msal-react";
import { MaterialReactTable } from "material-react-table";
import { Row } from "react-bootstrap";
import "./css/DocumentTable.css";
import PopUp from "../PopUp";
import DocumentColumns from "./DocumentColumns";

export default function DocumentTable({
  loading = false,
  documentResults,
  exclude,
  noAction,
}: IDocumentTableProps) {
  const { accounts } = useMsal();
  const [isAdvancedUser, setIsAdvancedUser] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupContent, setPopupContent] = useState<string[]>([]);
  const [popupTitle, setPopupTitle] = useState("");
  useEffect(() => {
    if (accounts?.[0]?.idTokenClaims?.roles?.includes("AdvancedUser")) {
      setIsAdvancedUser(true);
    }
  }, [accounts]);

  const columns = DocumentColumns({
    isAdvancedUser,
    setPopupContent,
    setShowPopup,
    setPopupTitle,
    exclude,
    noAction,
  });

  return (
    <>
      <Row className="margin-bottom">
        <div className="custom-doc-table">
          <MaterialReactTable
            columns={columns}
            state={{ isLoading: loading }}
            layoutMode="grid-no-grow"
            data={documentResults}
            enableTopToolbar={!noAction}
            enableHiding={false}
            enableDensityToggle={false}
            enableExpandAll={false}
            enableFullScreenToggle={!noAction}
            enableGlobalFilterModes={false}
            initialState={{
              density: "compact",
            }}
            enableBottomToolbar={false}
            enableColumnActions={false}
            enableColumnFilters={false}
            enablePagination={false}
            enableGlobalFilter={!noAction}
            enableSorting={!noAction}
            enableRowVirtualization={!noAction}
            enableColumnResizing={true}
            enableColumnPinning={false}
            defaultColumn={{
              size: 150,
            }}
          />
        </div>
      </Row>

      <PopUp
        showPopup={showPopup}
        setShowPopup={setShowPopup}
        popupTitle={popupTitle}
        popupContent={popupContent}
      />
    </>
  );
}
